export default __webpack_public_path__ + "static/media/T&C_ICONA.0d01eb3d.svg";